import { useMemo } from 'react';
import cn from 'classnames';
import { ReactComponent as Arrow } from '../../assets/icon/svg/left-arrow.svg';
import './pagination.css';

interface Props {
  currentPage: number;
  total: number;
  limit: number;
  onPaginationChange: (page: number) => void;
  isMobile?: boolean;
}

export const Pagination: React.FC<Props> = (props) => {
  const { onPaginationChange, currentPage, limit, total, isMobile } = props;

  const totalPages = Math.ceil(total / limit);

  const visiblePages = useMemo(() => {
    const maxVisiblePages = 5; // Максимальное кол-во страниц, можно подбить под себя как нравится
    const halfMaxVisiblePages = Math.floor(maxVisiblePages / 2);

    let startPage = Math.max(currentPage - halfMaxVisiblePages, 0);
    const endPage = Math.min(startPage + maxVisiblePages - 1, totalPages - 1);

    if (endPage - startPage + 1 < maxVisiblePages) {
      startPage = Math.max(endPage - maxVisiblePages + 1, 0);
    }

    return Array.from(
      { length: endPage - startPage + 1 },
      (_, i) => startPage + i
    );
  }, [currentPage, totalPages]);

  function handlePaginationChange (value: number): void {
    if (value < 0 || value >= totalPages) return;

    onPaginationChange(value);
  }

  return (
    <div className="pagination-wrapper">
      <nav>
        <ul className="pagination">
          <li className="page-item prev-next">
            {currentPage > 0 && (
              <button
                className="page-link"
                onClick={() => {
                  handlePaginationChange(currentPage - 1);
                }}
              >
                {isMobile === true
? (
                  <Arrow className="left-arrow" />
                )
: (
                  'Предыдущая'
                )}
              </button>
            )}
          </li>
          {visiblePages.map((page) => (
            <li className="page-item" key={page}>
              <button
                className={cn('page-link', page === currentPage && 'active')}
                onClick={() => {
                  handlePaginationChange(page);
                }}
              >
                {page + 1}
              </button>
            </li>
          ))}
          <li className="page-item prev-next">
            {currentPage < totalPages - 1 && (
              <button
                className="page-link"
                onClick={() => {
                  handlePaginationChange(currentPage + 1);
                }}
              >
                {isMobile === true
? (
                  <Arrow className="right-arrow" />
                )
: (
                  'Следующая'
                )}
              </button>
            )}
          </li>
        </ul>
      </nav>
    </div>
  );
};
